import * as React from 'react';
import { SVGProps } from 'react';

const IconSendMessageSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.451 2.118c-.822-.412-1.717.412-1.375 1.265l3.056 7.64 7.877.985-7.876.984-3.057 7.641c-.342.854.553 1.677 1.375 1.266l17.996-8.996a1 1 0 0 0 0-1.79L3.452 2.119Z" />
  </svg>
);
export default IconSendMessageSizeM;
